
import Vue from 'vue';
import { canVote } from '../api/index';
import { Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { getAuthToken } from '@/utils/authToken';
@Component
export default class Home extends Vue {
  vote: any = {
    can_vote: true,
  };
  created() {
    // this.vote = getVote();
    canVote().then((res: any) => {
      if (res && res.code === 200) {
        this.vote = res.data;
      }
    });
  }
  start() {
    if (!this.checkEnvironment()) return;
    if (isWeiXin() && !localStorage.getItem('unionid')) {
      this.$dialog
        .confirm({
          title: '微信登录',
          message: '参与点名前需要完成微信登录',
          confirmButtonText: '微信登录',
          cancelButtonText: '取消',
        })
        .then(() => this.wechatLogin())
        .catch(() => undefined);
      return;
    }
    this.$router.push({ path: '/20260901JQDM/pick' });
  }
  checkEnvironment() {
    if (isWeiXin()) return true;

    window.gettoken();

    if (window.udid) {
      const token = window.token;
      if (!token) {
        window.openApp('mUserLogin');
        window.handleMessage('{"action":"mUserLogin","data":""}');
        window.location.href = 'client:logout';

        return false;
      }
      return true;
    }
    this.$dialog
      .confirm({
        title: '友情提示',
        message: '请在微信中打开，或使用上游新闻App参与点名',
        confirmButtonText: '打开上游新闻App',
        cancelButtonText: '知道了',
        closeOnClickOverlay: true,
      })
      .then(() => {
        window.location.href =
          'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
      })
      .catch(() => undefined);
    return false;
  }
  wechatLogin() {
    location.href = `https://activity.cqcb.com/wechat-auth.html?appId=wx1949ed4a473b87ed&backUrl=${encodeURIComponent(
      location.href,
    )}`;
  }
  showToast(message: string) {
    this.$toast(message);
  }
  rank() {
    this.$router.push({ path: '/20260901JQDM/rank' });
  }
}
